import { Row, Col, Layout } from 'antd';
import styled, { createGlobalStyle } from 'styled-components';
import { color } from '../resources';
const { Header, Sider } = Layout;

const GlobalStyle = createGlobalStyle`
    @font-face {
        font-family: 'AnuphanRegular';
        src: url("../assets/fonts/OTF/Anuphan-Regular.otf") format("truetype");
    }
    @font-face {
        font-family: 'AnuphanBold';
        src: url("../assets/fonts/OTF/Anuphan-Bold.otf") format("truetype");
        font-weight: bold;
    }
    @font-face {
        font-family: 'AnuphanLight';
        src: url("../assets/fonts/OTF/Anuphan-Light.otf") format("truetype");
        font-weight: 100;
    }
    @font-face {
        font-family: 'AnuphanMedium';
        src: url("../assets/fonts/OTF/Anuphan-Medium.otf") format("truetype");
        font-weight: 600;
    }
    @font-face {
        font-family: 'Sarabun-Light';
        src: url("../assets/fonts/OTF/Sarabun-Light.ttf") format("truetype");
    }
    html, body {
        height: 100%;
        width: 100%;
        padding: 0;
        margin: 0;
        background: #FAFAFA;
        font-family: Sarabun-Light, 'sans-serif' !important;
        color: #444;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
`;

export const RowComponent = styled(Row)`
  display: flex;
  align-items: center;
`;

export const Required = styled.div`
  color: ${color.red};
  position: relative;
  top: 3px;
  left: 3px;
`;

export const ContainerButton = styled(Col)`
  text-align-last: ${(props) =>
    props.left ? 'start' : props.center ? 'center' : props.right ? 'end' : ''};
  width: 100%;
`;

export const HeaderBarStyle = styled(Header)`
  padding: 0 !important;
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
`;

export const SideBarStyle = styled(Sider)`
  overflow: auto;
  height: 100vh;
  position: fixed !important;
  left: 0;
  top: 0;
  bottom: 0;
`;
export const IconContainerDiv = styled.div`
  height: 100%;
  margin-top: 3px;
  margin-right: 1.5px;
`;
export const VersionTag = styled.div`
  text-align: center;
  display: ${({ collapse }) => (collapse ? 'none' : 'list-item')};
`;
export const StatusColumnContainer = styled.div`
  color: ${(props) => props.color};
  display: flex;
  justify-content: ${(props) => props.content || `center`};
`;

export default GlobalStyle;
